<template>
  <div class="followup-rule">
    <a-spin :spinning="submitLoading"  tip="提交中..." size="large">
      <a-form :form="form" @submit="addClueRuleConfig">
        <a-form-item>
          <div class="header-row">
            <h3>意向等级下次跟进时间规则</h3>
            <a-button
                type="danger"
                icon="plus"
                shape="circle"
                size="small"
                @click="handleAdd"
                style="margin-left: 10px;"
            >
            </a-button>
          </div>
          <div
              v-for="(rule, index) in clueRuleConfigList"
              :key="index"
              class="rule-item"
          >
            <span class="serial-number">({{ index + 1 }})</span>
            <span class="label">意向级别为</span>
            <a-select
                v-model="rule.intentionLevelArr"
                mode="multiple"
                placeholder="选择意向级别"
                class="select-level"
                @change="validate"
            >
              <a-select-option
                  v-for="opt in levelOptions"
                  :key="opt.codeId"
                  :value="opt.codeId"
              >
                {{ opt.codeName }}
              </a-select-option>
            </a-select>
            <span class="label">的线索时需要在，</span>
            <a-input-number
                v-model="rule.nextFollowTime"
                :min="1"
                class="input-days"
                @change="validate"
            />
            <span class="label">天内，完成跟进。</span>
            <a-button
                v-if="index > 0"
                type="danger"
                size="small"
                icon="minus"
                shape="circle"
                @click="handleDelete(index)"
                class="delete-btn"
                style="margin-left: 10px;"
            >
            </a-button>
          </div>
          <div style="color: red; margin-left: 8px;">
              {{ error }}
          </div>
          <!-- 提交按钮 -->
          <div class="submit-row">
            <a-button type="primary" html-type="submit"  style="margin-top: 16px;">
              提交
            </a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-spin>
  </div>
</template>

<script>
import { dataApi } from "@/services/comm/clueRuleConfig.js";
import {loadBaseCodeData} from "@/services/baseCodeSource";

export default {
  name: 'FollowupRule',
  components: {},
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      clueRuleConfigList: [
        {
          configId: undefined,
          intentionLevelArr: [],
          intentionLevel: undefined,
          nextFollowTime: undefined
        }, // 初始规则
      ],
      levelOptions: [], // 意向级别选项
      submitLoading: false,
      error: undefined
    };
  },
  async mounted() {
    this.levelOptions = await loadBaseCodeData('CD200002');
    console.log("levelOptions",this.levelOptions)
    this.findClueRuleConfig()
  },
  methods: {
    // 校验逻辑
    validate() {
      console.log("validate",this.clueRuleConfigList)
      this.error = undefined;
      const allLevels = [];

      for (let i = 0; i < this.clueRuleConfigList.length; i++) {
        const rule = this.clueRuleConfigList[i];
        console.log("validate",rule)
        allLevels.push(...rule.intentionLevelArr);
        // 校验意向级别
        if (!rule.intentionLevelArr || rule.intentionLevelArr.length === 0) {
          this.error = '意向级别不能为空';
          return false;
        }
        // 校验天数
        if (!rule.nextFollowTime || typeof rule.nextFollowTime !== 'number' || rule.nextFollowTime < 1) {
          this.error = '天数不能为空';
          return false;
        }
      }
      // 意向级别不能重复
      const uniqueLevels = new Set(allLevels);
      if (allLevels.length !== uniqueLevels.size) {
        this.error = '意向级别不能重复';
        return false;
      }

      return true;
    },

    // 新增规则
    handleAdd() {
      this.clueRuleConfigList.push({
        configId: undefined,
        intentionLevelArr: [],
        intentionLevel: undefined,
        nextFollowTime: undefined
      });
    },
    // 删除规则
    handleDelete(index) {
      this.clueRuleConfigList.splice(index, 1);
    },
    // 获取线索规则
    async findClueRuleConfig() {
      let res = await dataApi.findAll();
      console.log("findClueRuleConfig",res)
      if (res.code === 200) {
        this.clueRuleConfigList = res.data.map(item => {
          item.intentionLevelArr = item.intentionLevel
              .split(',')
              .map(Number)
              .filter(num => !isNaN(num));
          return item;
        });
      }
      console.log("clueRuleConfigList",this.clueRuleConfigList);
    },
    async addClueRuleConfig() {
      if (this.submitLoading) return;

      //校验
      let flag = this.validate();
      if (!flag) {
        return;
      }

      try {
        this.submitLoading = true;

        // 确保每个规则都已正确转换
        this.clueRuleConfigList.forEach(item => {
          item.intentionLevel = item.intentionLevelArr.join(',');
        });

        const res = await dataApi.fullSave(this.clueRuleConfigList);

        if (res.code === 200) {
          this.$message.success('保存成功');
        }
      } catch (error) {
        console.error("保存失败", error);
        this.$message.error('保存失败，请重试');
      } finally {
        this.submitLoading = false;
      }
    }
  },
};
</script>

<style scoped>
.followup-rule {
  padding: 16px; /* 页面内边距，增强可读性 */
}

/* 标题行：flex 布局，标题左对齐、按钮右对齐 */
.header-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

/* 每个规则项：flex 水平排列，元素紧凑对齐 */
.rule-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px; /* 规则项之间的垂直间距 */
}

/* 序号样式 */
.serial-number {
  margin-right: 8px; /* 序号与后续元素的间距 */
}

/* 固定文本标签（如“意向级别为”“的线索时需要在，”等） */
.label {
  margin: 0 4px; /* 标签左右小间距，让文本更紧凑 */
}

/* 意向级别下拉：调整宽度 + 间距 */
.select-level {
  width: 250px; /* 自动宽度（根据选项内容），也可设固定值如 100px */
  margin-right: 4px; /* 与后续元素的间距 */
}

/* 天数输入框：固定宽度 + 间距 */
.input-days {
  width: 60px; /* 紧凑宽度，可按需调整 */
  margin: 0 4px; /* 左右间距 */
}

/* 删除按钮：调整左侧间距 */
.delete-btn {
  margin-left: 8px;
}
</style>